import { render } from "./ClientPortal.vue?vue&type=template&id=38d0b328&scoped=true"
import script from "./ClientPortal.vue?vue&type=script&lang=js"
export * from "./ClientPortal.vue?vue&type=script&lang=js"

import "./ClientPortal.vue?vue&type=style&index=0&id=38d0b328&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38d0b328"]])

export default __exports__